import { Box, styled } from '@mui/material';

export const StyledModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.default,
  borderRadius: theme.customShape.borderRadius5XL,
  boxShadow: '0 144px 250px 0 rgb(221 253 108 / 40%)',
  display: 'inline-flex',
  padding: theme.spacing(12),
}));
